import { useQuery } from '@apollo/client/react';
import type { FC } from 'react';

import { FormSelect } from '@zen/Components';
import type { Option } from '@zen/DesignSystem/types';

import { GetEnterpriseConnectionsDocument, type GetEnterpriseConnectionsQueryResult } from '../graphql';
import type { EnterpriseConnection } from '../types';

const prepareEnterpriseConnectionOptions = (connectionNames: EnterpriseConnection): Option<string>[] =>
  connectionNames?.map((connectionName: string): Option<string> => {
    return {
      label: connectionName || '',
      value: connectionName || ''
    };
  }) || [];

interface Props {
  isDisabled: boolean;
}
const FormEnterpriseConnectionSelect: FC<Props> = ({ isDisabled }) => {
  const { data, loading } = useQuery<GetEnterpriseConnectionsQueryResult>(GetEnterpriseConnectionsDocument);

  const connectionNames = data?.enterpriseConnectionNames;

  const locationOptions: Option<string>[] = prepareEnterpriseConnectionOptions(connectionNames);

  return <FormSelect isDisabled={isDisabled} isLoading={loading} name="connectionName" options={locationOptions} />;
};

export default FormEnterpriseConnectionSelect;
